/** Identifies which brand logo to render in the content-area page header. Set per route via `pageHeaderSettings`. */
export type ContentHeaderLogoKey = 'billpay' | 'ecommerce';

/**
 * Presentation details for a content-header logo: the asset filename (resolved through the `assetSource` pipe),
 * the alt text, the intrinsic dimensions required by `NgOptimizedImage` to reserve layout space, and which side
 * of the content header the logo renders on.
 */
export interface ContentHeaderLogo
{
    asset: string;
    alt: string;
    width: number;
    height: number;
    position: 'left' | 'right';
}

/**
 * Maps each logo key to its presentation details. Adding a new brand logo is a single entry here plus the
 * `contentHeaderLogo` key on the relevant routes. Widths/heights follow each asset's intrinsic aspect ratio.
 */
export const CONTENT_HEADER_LOGOS: Record<ContentHeaderLogoKey, ContentHeaderLogo> = {
    billpay: {asset: 'secondary-logo.png', alt: 'Pay@ Go', width: 55, height: 40, position: 'right'},
    ecommerce: {asset: 'Payat-Gateway-Vertical.svg', alt: 'Pay@ Gateway', width: 66, height: 40, position: 'left'}
};
